import React from "react";

export function SummaryRow(props) {
  const label = props.label;
  const value = props.value;
  const labelClassName = props.labelClassName || "";
  const valueClassName = props.valueClassName || "";

  return (
    <div className="flex justify-between">
      <span className={labelClassName}>{label}</span>
      <span className={"font-semibold " + valueClassName}>{value}</span>
    </div>
  );
}

export function SummaryBox(props) {
  const children = props.children;
  const className = props.className || "";

  return (
    <div className={"rounded-xl bg-palette-gray-soft p-3 space-y-2 " + className}>{children}</div>
  );
}
